import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import headerLogo from "../assets/logo/Header.svg";
import "./Header.css";
import ArrowButton from "./ArrowButton";
import FullPageMenu from "./FullPageMenu";
import { useContactModal } from "../context/ContactContext";

const Header = () => {
  const { openContactModal } = useContactModal();
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        // scrolling down
        setHidden(true);
      } else {
        // scrolling up
        setHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleServicesClick = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("services");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("services");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    }
  };

  const handlePricingClick = () => {
    if (location.pathname === "/") {
      const el = document.getElementById("pricing");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("pricing");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    }
  };

  const handleWorkClick = () => {
    navigate("/sample-work");
  };

  const isWorkActive = location.pathname === "/sample-work" || location.pathname.startsWith("/sample-work");
  const isServicesActive = location.pathname === "/services";

  return (
    <div className={`header ${hidden ? "hide" : ""}`}>
      <div className="headerContainer">
        <header>
          <Link to="/">
            <img
              src={headerLogo}
              className="header-logo-container"
              style={{ width: "166px", height: "52px" }}
              alt="Header Logo"
            />
          </Link>
        </header>

        <div className="headerRight">
          {/* Segmented Nav Pill Bar */}
          <div className="nav-segmented-pill">
            <button
              type="button"
              className={`segmented-tab ${isServicesActive ? "active" : ""}`}
              onClick={handleServicesClick}
            >
              Services
            </button>
            <button
              type="button"
              className={`segmented-tab ${isWorkActive ? "active" : ""}`}
              onClick={handleWorkClick}
            >
              Magical Work
            </button>
            <button
              type="button"
              className="segmented-tab"
              onClick={handlePricingClick}
            >
              Pricing
            </button>
          </div>

          {/* Contact Us Arrow Button */}
          <ArrowButton text="Contact Us" onClick={openContactModal} />

          {/* Full Page Menu */}
          <FullPageMenu />
        </div>
      </div>
    </div>
  );
};

export default Header;
